"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModalPadding = exports.breakpointForScreenWidth = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var breakpointForScreenWidth = function breakpointForScreenWidth(windowWidth) {
  var windowBreakpoint = 'Mobile';

  if (windowWidth >= _designLanguage.Breakpoints.Desktop) {
    windowBreakpoint = 'Desktop';
  }

  if (windowWidth >= _designLanguage.Breakpoints.Tablet && windowWidth < _designLanguage.Breakpoints.Desktop) {
    windowBreakpoint = 'Tablet';
  }

  return windowBreakpoint;
};

exports.breakpointForScreenWidth = breakpointForScreenWidth;

var getModalPadding = function getModalPadding(usesDynamicBreakpoint, windowBreakpoint) {
  if (usesDynamicBreakpoint && _constants.ContentPadding.hasOwnProperty(windowBreakpoint)) {
    return _constants.ContentPadding[windowBreakpoint];
  }

  return _designLanguage.Spacing.Small;
};

exports.getModalPadding = getModalPadding;